module.exports = __webpack_public_path__ + "img/BENEFICIOS.ba9de433.jpg";